<template>
  <PlatformRenderer>
    <template v-slot:onMobile>
      <div class="w-100">
        <WCSpinner v-if="loading || isLoading" size="xl" position="center" />
        <template v-else-if="currentOrder">
          <WCMobileOrderInProgress
            v-if="
              currentOrder.status.stage === 0 ||
                currentOrder.status.stage === 1 ||
                currentOrder.status.stage === 2
            "
            :order="currentOrder"
            @cancelOrder="cancelOrder"
            @editOrder="editOrder"
          />
          <WCMobileOrderComplete v-else :order="order" @receipt="viewReceipt" ref="orderPanelRef" />
        </template>
        <p v-else class="text-center">{{ $t('orderNotValid') }}</p>
      </div>
    </template>
    <template v-slot:onDesktop>
      <div class="p-3">
        <WCSpinner v-if="loading || isLoading" size="xl" position="center" />
        <WCOrderPanel
          v-else-if="currentOrder"
          :order="currentOrder"
          @cancelOrder="cancelOrder"
          @editOrder="editOrder"
          @receipt="viewReceipt"
          ref="orderPanelRef"
        />
        <p v-else class="text-center">{{ $t('orderNotValid') }}</p>
      </div>
    </template>
  </PlatformRenderer>
</template>

<script>
import PlatformRenderer from '@/modules/platform/components/PlatformRenderer';
import axios from 'axios';
import WCMobileOrderInProgress from '@/modules/orders/components/WCMobileOrderInProgress/WCMobileOrderInProgress.vue';
import WCMobileOrderComplete from '@/modules/orders/components/WCMobileOrderComplete/WCMobileOrderComplete.vue';
import { mapActions, mapGetters } from 'vuex';
import WCOrderPanel from '../../components/WCOrderPanel/WCOrderPanel.vue';
import WCSpinner from '../../../../components/WCSpinner/WCSpinner.vue';
import OrderPanelMixin from '../../mixins/OrderPanelMixin';

export default {
  components: {
    PlatformRenderer,
    WCMobileOrderInProgress,
    WCMobileOrderComplete,
    WCOrderPanel,
    WCSpinner,
  },

  mixins: [OrderPanelMixin],

  created() {
    this.updateData();
  },
  computed: {
    ...mapGetters({
      isLoading: 'cart/isLoading',
    }),
  },
  methods: {
    ...mapActions({
      reloadCart: 'cart/reload',
    }),
    async updateData() {
      this.loading = true;
      this.currentOrder = null;

      try {
        const sc = this.$route.params.scancode;
        const response = await axios.get(`/api/me/orders/${sc}`);
        this.currentOrder = response.data;

        this.loadError = null;
      } catch (error) {
        const code = error.payload && error.payload.code ? error.payload.code : 500;
        this.loadError = `Order History is not currently available. Please try again later. Code ${code}.`;
      } finally {
        this.loading = false;
      }
    },
  },
  data() {
    return {
      currentOrder: null,
      loadError: null,
      loading: false,
    };
  },
};
</script>

<style lang="scss" scoped></style>
